/**
    @prop --uic-accordion-summary-height: the height of the summary panel
    @prop --uic-accordion-content-background: the background of content inside the accordion
    @prop --uic-accordion-content-padding: the padding around content inside the accordion
*/

.uic-accordion-item {
  display: block;
  position: relative;

  &__header {
    --uic-icon-width: var(--uic-icon-dimensions-default);
    --uic-icon-height: var(--uic-icon-dimensions-default);
    --top-border-color: transparent;

    @include font(normal);
    align-items: center;

    appearance: none;
    background: var(--uic-color-white);
    border: 0;
    box-sizing: border-box;
    color: var(--uic-color-black);
    cursor: pointer;

    display: flex;
    gap: 8px;
    height: var(--uic-accordion-summary-height);
    outline: none;
    padding: 0 16px;
    width: 100%;

    &::before {
      border-bottom: 1px solid var(--uic-color-black);
      border-top: 1px solid var(--top-border-color);
      bottom: 0;
      content: '';
      left: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: -1px;
      z-index: 1;
    }

    &:disabled {
      color: var(--uic-color-grey5);
      pointer-events: none;
    }

    &:focus-visible::before {
      border-color: var(--uic-color-blue2);
      border-width: 2px;
    }

    &:active {
      background: var(--uic-color-blue1a10);
    }

    &:hover::before,
    &:active::before {
      border-color: var(--uic-color-blue2);
      border-width: 1px;
    }

    &:hover,
    &:active {
      color: var(--uic-color-blue3);
    }
  }

  &__content {
    background: var(--uic-accordion-content-background);
    box-sizing: border-box;
    display: none;
    min-height: 64px;
    padding: var(--uic-accordion-content-padding);
  }

  &--open {
    .uic-accordion-item__header {
      font-weight: var(--uic-font-weight-semibold);

      &:not(:active, :hover) {
        color: var(--uic-color-blue4);
      }
    }

    .uic-accordion-item__chevron {
      transform: rotate(180deg);
    }

    .uic-accordion-item__content {
      display: block;
    }
  }

  &:first-of-type .uic-accordion-item__header {
    --top-border-color: var(--uic-color-black);
  }
}
